export default __webpack_public_path__ + "static/media/Pain's Edge.82739edf.jpg";